module.exports = __webpack_public_path__ + "static/media/cert_156.5dd35ac6.jpg";